import { count_occurences } from "./helpers.js";
function closeBraces(retained_template, template) {
  for (var placeholder = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "x", empty_placeholder = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : " ", cut_before = retained_template.length, opening_braces = count_occurences("(", retained_template), closing_braces = count_occurences(")", retained_template), dangling_braces = opening_braces - closing_braces; dangling_braces > 0 && cut_before < template.length; )
    retained_template += template[cut_before].replace(placeholder, empty_placeholder), template[cut_before] === ")" && dangling_braces--, cut_before++;
  return retained_template;
}
export {
  closeBraces as default
};
//# sourceMappingURL=closeBraces.js.map
